module.exports = __webpack_public_path__ + "static/media/bill-item-discount.e9693156.svg";